<template>
  <vetster-search-facet-group
    :label="$t('search.appointment-type')"
    group="APPOINTMENT"
    :expanded="expanded"
  >
    <label
      v-for="(option, i) in getDesignationOptions"
      :key="i"
      :for="option.value"
      class="flex items-center"
    >
      <input
        :id="option.value"
        v-model="input"
        :value="option.value"
        type="radio"
        class="cursor-pointer focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-neutral-300"
      />
      <span class="ml-3 block text-sm font-base text-neutral-700 cursor-pointer">
        <div class="font-medium">{{ option.text }}</div>
        <div class="font-light text-neutral-500">{{ option.subtext }}</div>
      </span>
    </label>
    <a
      href="https://support.vetster.com/en/should-i-book-with-vetster-wellness-or-vetster-medical"
      class="text-xs text-indigo-600 hover:text-indigo-400 transition ease-in-out duration-250 flex items-center focus:outline-none focus:underline"
      rel="noopener"
      target="_blank"
    >
      <fa
        :icon="['fal', 'question']"
        class="text-sm text-indigo-500 mr-1"
      />
      {{ $t('vetster.help-me-choose-an-appointment-type') }}
    </a>
  </vetster-search-facet-group>
</template>

<script>
import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';
import useSearchData from '@/composables/use-search-data';

export default {
  name: 'VetsterSearchDesignationInput',

  components: { VetsterSearchFacetGroup },

  props: {
    expanded: {
      default: true,
      type: Boolean,
    },
  },

  setup() {
    const { getDesignationOptions } = useSearchData();

    return { getDesignationOptions };
  },

  computed: {
    input: {
      get() {
        return this.$store.state.search.inputs.designation;
      },

      set(designation) {
        this.$store.commit('search/setInputs', { designation });
      },
    },
  },
};
</script>
